<template>
  <div class="question-view-dialog" >
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" :safe="false"/>
      </div>

      <div class="choice-list">
        <div class="choice-single" v-show="its.content" v-for="(its, idx) in choice" :key="idx" :id="'single' + idx" draggable="true" @dragstart="dragStart($event, idx)">
          <vue-mathjax v-if="its.type == 'text'" :formula="its.content" :safe="false"/>
          <div class="image" v-else :style="{backgroundImage: `url(${its.content})`}"></div>
        </div>
      </div>

      <div class="area">
        <div class="area-single" @drop="drop($event, key)" @dragover="dragover($event)" 
          v-for="(key, idx) in Object.keys(area)" :key="idx">
          <div class="area-name">
            <vue-mathjax :formula="area[key].name" :safe="false"/>
          </div>
          <div class="drag-area">
            <div class="sle-choice determine-success-br" @click="removeAnswer(key, index)" v-for="(its, index) in area[key].areaData" :key="index">
              <vue-mathjax v-if="its.type == 'text'" :formula="its.content" :safe="false"/>
              <div class="image" v-else :style="{backgroundImage: `url(${its.content})`}"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['form', 'mode'],
  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))

    return {
      letter,
      topic: '请将选项拖拽至正确的空格中。',
      
      choice: [],
      question: [],

      area: {
        left: {
          name: '正方形',
          areaData: [],
          isExist: []
        },
        right: {
          name: '长方形',
          areaData: [],
          isExist: []
        },
      },
      answer_results: {
        id: null,
        student_choices: []
      },
      recordQuestion: []
    }
  },
  watch: {
    'form.id': {
      handler() {
        this.initData()
      },
      deep: true
    }
  },
  methods: {
    dragStart(e, idx) {
      e.dataTransfer.setData('textDragMsg', idx)
    },

    dragover(e) {
      e.preventDefault()
    },

    drop(e, key) {
      // 存在 e.target 为子节点  不是「填空区域」获取父节点后再作处理
      let eareBox = e.target, { area } = this
      while(!eareBox.classList.contains('area-single')) {
        eareBox = eareBox.parentNode
      }

      let idx = e.dataTransfer.getData('textDragMsg'),
      cte = this.choice[idx].content
      // console.log(this.choice[idx])
      // console.log(area[key])
      if(!area[key].isExist.includes(cte)) {
        area[key].isExist.push(cte)
        area[key].areaData.push(this.choice[idx])
      }
    },
    // 移除答案
    removeAnswer(key, idx) {
      this.area[key].areaData.splice(idx, 1)
      this.area[key].isExist.splice(idx, 1)

      // console.log(this.area[key])
    },
    initData() {
      this.answer_results = {
        id: null,
        student_choices: []
      }
      this.recordQuestion = []
      this.choice = []
      this.question = []

      this.area = {
        left: {
          name: '正方形',
          areaData: [],
          isExist: []
        },
        right: {
          name: '长方形',
          areaData: [],
          isExist: []
        },
      }

      let content = JSON.parse(this.form.content)
      // console.log(content)
      for(let i = 0; i < content.ligatureList.length; i++) {
        let {right} = content.ligatureList[i]
        if(right.type == 'text')
          this.choice.push({content: right.textValue, type: 'text'})
        else
          this.choice.push({content: right.imgValue, type: 'image'})
      }
      for(let i = 0; i < content.ligatureList.length; i++) {
        let {left} = content.ligatureList[i]
        if(left) {
          let areaKeys = Object.keys(this.area)
          this.area[areaKeys[i]].name = left.value
          // 还原答案
          let data = this.choice.filter((its, i) => left.rightTips.includes(i) && its)
          this.area[areaKeys[i]].areaData = JSON.parse(JSON.stringify(data))
          this.area[areaKeys[i]].isExist = JSON.parse(JSON.stringify(data))
        }
      }
      if(this.mode == 'viewAnswer') setTimeout(() => this.showTrueFalse(), 500)
    }
  },
  created() {
    // transfer.$on('textDrag', ({question, topic, choice}) => {
    //   this.topic = topic
    //   this.question = JSON.parse(JSON.stringify(question))
    //   this.choice = JSON.parse(JSON.stringify(choice))
    // })
    this.initData()
  }
}
</script>

<style scoped lang="scss">
.question-view-dialog {
  width: 100%;
  height: 400px;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px;
  .quest {
    width: 100%;
    height: 100%;
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;

    .title {
      width: 100%;
      font-size: 15px;
      color: #333;
    }

    .choice-list {
      width: 100%;
      margin-top: 20px;
      display: flex;
      justify-content: flex-start;
      align-content: flex-start;
      flex-wrap: wrap;
      // grid-template-columns: repeat(5, 100px);
      // grid-template-rows: repeat(2, 34px);
      // grid-row-gap: 10px;
      // grid-column-gap: 10px;
      .choice-single {
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        min-width: 60px;
        width: fit-content;
        height: fit-content;
        padding: 10px;
        background-color: #f8ae64;
        border-radius: 8px;
        box-shadow: 1px 2px 2px 1px #ccc;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        margin: 0 10px 10px 0;
        box-sizing: border-box;

        &:hover {
          opacity: .8;
        }

        .image {
          width: 60px;
          height: 60px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
        }
      }
    }

    .area {
      width: 100%;
      min-height: 240px;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .area-single {
        width: calc(50% - 20px);
        height: 100%;
        background-color: #fee8d2;
        border-radius: 30px;

        .area-name {
          width: 100%;
          height: 40px;
          background-color: #fcd2ab;
          color: #333;
          text-align: center;
          font-weight: 700;
          font-size: 18px;
          line-height: 40px;
          border-radius: 30px 30px 0 0;
        }

        .drag-area {
          width: 100%;
          height: calc(100% - 40px);
          padding: 10px 0 0 10px;
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          justify-content: flex-start;
          align-content: flex-start;

          .sle-choice {
            text-align: center;
            box-shadow: 1px 2px 2px 1px #ccc;
            min-width: 60px;
            width: fit-content;
            height: fit-content;
            padding: 10px;
            border-radius: 5px;
            background-color: #f8ae64;
            margin-right: 10px;
            margin-bottom: 10px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;

            &:hover {
              opacity: .7;
            }
            .image {
              width: 60px;
              height: 60px;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center center;
            }
          }
        }
      }
    }

  }
}
</style>